export default {
  oidc: {
    clientId: '0oaeeszdef5jjRh9Y4x7',
    issuer: 'https://okta.batchelor.net.au/oauth2/default',
    redirectUri: window.location.origin + '/login/callback',
    scopes: ['openid', 'profile', 'email', 'offline_access']
  }
}